// import $ from "jquery";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

class actBannerSlider {
  Swipes = null;
  selector = null;
  constructor() {
    this.selector = document.querySelector('.no-slider');
    this.sliderInit();
    this.resize();
  }

  sliderInit() {
    if (!this.selector) {
      Swiper.use([Navigation, Pagination, Autoplay]);
      this.Swipes = new Swiper('.act-banner-slider', {
        slidesPerView: 'auto',
        grabCursor: true,
        autoplay: {
          delay: 2000,
        },
        loop: true,
        speed: 1000,

        allowTouchMove: true,
        // autoHeight: true,
        pagination: {
          el: '.act-banner-slider .slider__pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.act-banner-slider .slider__button-next',
          prevEl: '.act-banner-slider .slider__button-prev',
        },
      });
    } else {
      if (window.innerWidth < 1280) {
        Swiper.use([Navigation, Pagination, Autoplay]);
        this.Swipes = new Swiper('.act-banner-slider', {
          slidesPerView: 'auto',
          grabCursor: true,
          loop: false,
          speed: 500,
          allowTouchMove: true,
          // autoHeight: true,
          pagination: {
            el: '.act-banner-slider .slider__pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.act-banner-slider .slider__button-next',
            prevEl: '.act-banner-slider .slider__button-prev',
          },
        });
      } else {
        if (this.Swipes) {
          this.Swipes.disable();
          this.Swipes.setProgress(0);
        }
      }
    }
  }
  resize() {
    window.addEventListener('resize', () => {
      this.sliderInit();
    });
  }
}

export default actBannerSlider;
new actBannerSlider();
